import React, { FC } from 'react';
import { IPlayer } from '@base/features/player/model/interfaces';
import styles from '../styles/avatar.module.scss';

type PropsType = {
  classes?: string;
  player: IPlayer;
  children?: never;
};

export const Avatar: FC<PropsType> = ({ classes, player }: PropsType) => {
  let url = player.avatarUrl();
  const avatar = player.avatar;

  //ToDo Проверить, почему у Jon_Katana нет player.userId
  //if (player.name === 'Jon_Katana') console.log(player.name, player.userId, url);

  if (url === 'system') {
    url = `assets/avatars/${avatar}.png`;
    classes += ' avatar--system';
  } else {
    classes += ' avatar--custom';
  }

  return <div className={`${styles.avatar} ${classes}`}>{url && <img src={url} alt="" />}</div>;
};
